import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { selectLocalConfig } from 'store/app/reducer'


const CONFIG_KEY = "RORO_LOCAL_CONFIG"

export const loadLocalConfig = () => {
    const conf = localStorage.getItem(CONFIG_KEY)
    if(conf) {
        return  JSON.parse(conf)
    }
    return null
}

const LocalConfigPersist = ({ localConfig }) => {
    useEffect(() => {
        console.log("local config has changed")
        console.log(localConfig)
        if (localConfig) {
            localStorage.setItem(CONFIG_KEY, JSON.stringify(localConfig))
        }
    }, [localConfig])
    return <></>
}


const mapStateToProps = (state) => ({
    localConfig: selectLocalConfig(state)
})

export default connect(mapStateToProps)(LocalConfigPersist)
